<template>
  <div>
    <ul class="information">
      <li>
        <nut-textinput v-model="mobile" label="手机：" placeholder="请准确填写" :clearBtn="true" :disabled="false" />
      </li>
      <li>
        <nut-textinput v-model="name" label="姓名：" placeholder="请输入姓名" :clearBtn="true" :disabled="false" />
      </li>
      <li>
        <nut-textinput v-model="birthday" label="生日：" placeholder="格式:20201201" :clearBtn="true" :disabled="false" />
      </li>
    </ul>
    <div class="submit-btn">
      <nut-button @click="setUserInfoMethods" block shape="circle">确认提交</nut-button>
    </div>
  </div>
</template>
<script>
import { setUserInfo } from '@/views/mobile/PublicApp/apis'
import { getUserInfo } from '@/views/mobile/MemberCenter/apis'
export default {
  data () {
    return {
      mobile: '',
      name: '',
      birthday: ''
    }
  },
  methods: {
    requestUserInfo () {
      let data = new FormData()
      data.append('fromUrl', window.location.href)
      getUserInfo(data)
        .then(result => {
          if (result) {
            let userInfo = result.data
            this.mobile = userInfo.mobile
            this.name = userInfo.name
            this.birthday = (userInfo.birthday).replace(/-/g, '')
          }
        })
    },
    setUserInfoMethods () {
      let data = new FormData()
      data.append('mobile', this.mobile)
      data.append('name', this.name)
      data.append('birthday', this.birthday)
      setUserInfo(data)
        .then(result => {
          if (result) {
            this.$toast.success('操作成功！')
            this.$router.push('/memberCenter')
          }
        })
    }
  },
  mounted () {
    this.requestUserInfo()
  },
  created () {
    let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'))
    let shop = window.location.hostname.split('.')[0]
    if (shop === 'szty') {
      document.title = '陶源酒家'
    } else if (userInfo.ext.shopname !== '') {
      document.title = userInfo.ext.shopname
    } else {
      document.title = '香港富临皇宫'
    }
  }
}
</script>
<style lang="less">
.information {
  font-size: 14px;
  padding-top: 20px;
  li {
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 12px 20px;
    .nut-textinput input {
      height: 48px;
    }
  }
}
.nut-textinput input {
  font-size: 14px;
}
.submit-btn {
  height: 48px;
  padding: 40px 30px;
  .nut-button {
    float: left;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/PublicApp/components/Personal.vue